import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RootState } from "src/app/root-store/root-state";
import { KwikspaceStoreState } from "../state";

export const featureKey = "kwikspaceApp";

const getKwikspaceAppState = createFeatureSelector<RootState, KwikspaceStoreState>(
  featureKey
);

export const getQuoteList = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.quotes
);

export const getQuoteListRes = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.quotes.results
);

export const getQuoteListLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.quotesLoading
);

export const getQuoteListError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.quotesError
);

export const getQuote = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.quote
);

export const getQuoteLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.quoteLoading
);

export const getQuoteError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.quoteError
);

export const createRentalQuoteSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createRentalQuoteSuccess
);

export const createRentalQuoteLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createRentalQuoteLoading
);

export const createRentalQuoteError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createRentalQuoteError
);

export const getCreatedRentalQuote = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createdRentalQuote
);

export const createPurchaseQuoteSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createPurchaseQuoteSuccess
);

export const createPurchaseQuoteLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createPurchaseQuoteLoading
);

export const createPurchaseQuoteError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createPurchaseQuoteError
);

export const getCreatedPurchaseQuote = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createdPurchaseQuote
);

export const getCreatedLineItems = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createdPurchaseLineItems
);

export const getCreatedLineItemsLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createPurchaseLineItemLoading
);

export const getCreatedLineItemsError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createPurchaseLineItemError
);

export const getCreatedLineItemsSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.createPurchaseLineItemSuccess
);

export const updateQuoteSuccess = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.updateQuoteSuccess
);

export const updateQuoteLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.updateQuoteLoading
);

export const updateQuoteError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.updateQuoteError
);

export const getDownloadQuoteLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.downloadQuoteLoading
);

export const getDownloadQuoteError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.downloadQuoteError
);

export const getDownloadPurchaseQuoteLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.downloadPurchaseQuoteLoading
);

export const getDownloadPurchaseQuoteError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.downloadPurchaseQuoteError
);

export const getReport = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.report
);

export const getReportLoading = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.reportLoading
);

export const getReportError = createSelector(
  getKwikspaceAppState,
  (state) => state.quote.reportError
);
